import React from 'react';

//components
import Container from 'components/Container';

/**
 * 2×2 service banner grid under the homepage product marquees (styled
 * after 2rinkan.jp's promo tiles): photo背景 + dark gradient + bold
 * title, linking out to the group's dealership / workshop / rental
 * businesses. Static by design — the four destinations were specified
 * directly; images live in public/images/home-services (sourced from
 * the linked sites' own hero/og assets).
 */
const BANNERS = [
  {
    key: 'dealer',
    title: '電單車經銷',
    subtitle: '26KING 新車・現貨・訂購',
    href: 'https://www.26king.hk/inventory.html',
    image: '/images/home-services/dealer.jpg',
  },
  {
    key: 'service',
    title: '維修保養服務',
    subtitle: '維修・保養・改裝',
    href: 'https://www.26king.hk/services.html',
    image: '/images/home-services/service.jpg',
  },
  {
    key: 'japan',
    title: '日本自駕遊',
    subtitle: 'Rental819 日本電單車租賃',
    href: 'https://rental819.hk/',
    image: '/images/home-services/japan.jpg',
  },
  {
    key: 'hkrental',
    title: '香港租車體驗',
    subtitle: 'RentalBike.HK 香港電單車租賃',
    href: 'https://rentalbike.hk/zh-hant',
    image: '/images/home-services/hkrental.jpg',
  },
];

export default function ServiceBanners() {
  return (
    <section className="pb-14">
      <Container>
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {BANNERS.map((b) => (
            <a
              key={b.key}
              href={b.href}
              target="_blank"
              rel="noreferrer noopener"
              className="group relative block aspect-[5/2] overflow-hidden rounded-xl bg-hk-deep-blue"
            >
              <img
                src={b.image}
                alt={b.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-70 transition-transform duration-300 ease-out group-hover:scale-105 group-hover:opacity-80"
              />
              <div
                aria-hidden
                className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent"
              ></div>
              <div className="absolute inset-0 flex flex-col justify-center p-6 md:p-8">
                <p className="mb-1 text-xs font-medium tracking-widest text-hk-orange md:text-sm">
                  {b.subtitle}
                </p>
                <h3 className="flex items-center gap-2 text-xl font-bold text-white md:text-2xl">
                  {b.title}
                  <span
                    aria-hidden
                    className="text-hk-orange transition-transform duration-300 group-hover:translate-x-1.5"
                  >
                    →
                  </span>
                </h3>
              </div>
            </a>
          ))}
        </div>
      </Container>
    </section>
  );
}
